import React, { useEffect, useState } from "react";
import EmberlineLogo from "./EmberlineLogo";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#story", label: "Story" },
  { href: "#builds", label: "Previous Commissions" },
  { href: "#inquiry", label: "Contact Us" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/85 backdrop-blur-xl border-b border-zinc-900"
          : "bg-transparent border-b border-transparent"
      }`}
      data-testid="site-nav"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 lg:px-16 flex items-center justify-between h-20">
        <a href="#top" className="z-10 block" data-testid="nav-logo-link">
          <EmberlineLogo variant="nav" className="h-14 w-14 md:h-16 md:w-16" />
        </a>

        <nav className="hidden lg:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-heading uppercase text-base tracking-[0.22em] text-zinc-300 hover:text-[#FF7A00] transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#inquiry"
          data-testid="nav-cta-commission"
          className="hidden lg:inline-flex items-center justify-center px-6 py-3 font-heading uppercase tracking-[0.18em] text-sm bg-[#D9501E] text-white border border-[#D9501E] hover:bg-[#E86A33] hover:border-[#E86A33] transition-all duration-300"
        >
          Contact Us
        </a>

        <button
          aria-label="Toggle menu"
          onClick={() => setOpen((s) => !s)}
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-zinc-200 p-2 -mr-2"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-black/95 border-t border-zinc-900" data-testid="nav-mobile-panel">
          <div className="px-6 py-8 flex flex-col gap-6">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="font-heading uppercase text-2xl tracking-[0.22em] text-zinc-200 hover:text-[#FF7A00]"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#inquiry"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="mt-2 inline-flex items-center justify-center px-6 py-4 font-heading uppercase tracking-[0.18em] text-sm bg-[#D9501E] text-white"
            >
              Contact Us
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
